import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { buscarSessao, logout } from "../../auth/authActions";
import DateFormat from "../../common/dateFormat/DateFormat";
import { withRouter } from "react-router-dom";
import avatar from "../../assets/images/avatar.png";
import whatsappLogo from "../../assets/images/whatsapp_logo.png";

import { getLista as getListaNotificacao, setVisto as setNotificacaoVista, setLida as setNotificacaoLida } from "../../notificacao/notificacaoActions";
import { ModalAlert } from "../dialog/modalAlert";
import LabelAndInput from "../form/labelAndInput";
import Row from "../layout/row";
import Grid from "../layout/grid";
import Button from "../button/button";
import { alterarPerfil } from "../../usuario/usuarioActions";

const formDefault = { nome: null, login: null };
const INITIAL_STATE = { notificacaoOpen: false, exibirModalEditarPerfil: false, exibirCampoNovaSenha: false, form: { ...formDefault } };

function Navbar(props) {
    const [state, setState] = useState(INITIAL_STATE);

    useEffect(() => {
        props.buscarSessao();
        props.getListaNotificacao();
        const interval = setInterval(() => {
            props.getListaNotificacao();
        }, 600000);

        return () => clearInterval(interval);
    }, []);

    if (!props.usuarioLogado) return null;
    const { nome, login } = props.usuarioLogado;

    let dataNotificacao = null;
    let diasSemana = ["Domingo", "Segunda-Feira", "Terça-Feira", "Quarta-Feira", "Quinta-Feira", "Sexta-Feira", "Sábado"];

    return (
        <ul className="navbar-nav ml-auto">
            <ModalAlert
                showModal={state.exibirModalEditarPerfil}
                handleClose={() => setState({ ...state, exibirModalEditarPerfil: false, exibirCampoNovaSenha: false, form: { ...formDefault } })}
            >
                <div className="d-flex flex-column justify-content-center align-items-center text-dark">
                    <p>Editar Perfil</p>
                </div>
                <Row alignRight style={{ paddingRight: 5 }}>
                    <LabelAndInput
                        name="nome"
                        label="Nome *"
                        placeholder="Informe o Nome"
                        cols="12 12 12 12"
                        value={state.form.nome}
                        onChange={(e) => {
                            setState({
                                ...state,
                                form: { ...state.form, nome: e.target.value },
                            });
                        }}
                    />
                    <LabelAndInput
                        name="login"
                        label="Login *"
                        placeholder="Informe o Usuário"
                        cols="12 12 12 12"
                        value={state.form.login}
                        onChange={(e) => {
                            setState({
                                ...state,
                                form: { ...state.form, login: e.target.value },
                            });
                        }}
                    />
                    <Grid cols="12 12 12 12">
                        <Row>
                            {state.exibirCampoNovaSenha ? (
                                <>
                                    <Grid cols="12 12 12 12" style={{ padding: "10px 0px" }}>
                                        <Button
                                            text="Manter Senha Atual"
                                            type={"danger"}
                                            icon={"fa fa-times"}
                                            event={() => {
                                                setState({
                                                    ...state,
                                                    exibirCampoNovaSenha: false,
                                                    form: { ...state.form, senha_atual: undefined, nova_senha: undefined },
                                                });
                                            }}
                                        />
                                    </Grid>

                                    <LabelAndInput
                                        name="senha_atual"
                                        type="password"
                                        label="Senha Atual *"
                                        placeholder="Informe a senha atual"
                                        cols="12 12 12 12"
                                        value={state.form.senha_atual}
                                        onChange={(e) => {
                                            setState({
                                                ...state,
                                                form: { ...state.form, senha_atual: e.target.value },
                                            });
                                        }}
                                    />
                                    <LabelAndInput
                                        name="nova_senha"
                                        type="password"
                                        label="Nova Senha *"
                                        placeholder="Informe a nova senha"
                                        cols="12 12 12 12"
                                        value={state.form.nova_senha}
                                        onChange={(e) => {
                                            setState({
                                                ...state,
                                                form: { ...state.form, nova_senha: e.target.value },
                                            });
                                        }}
                                    />
                                </>
                            ) : (
                                <Grid cols="12 12 12 12" style={{ padding: "10px 0px", marginBottom: 20 }}>
                                    <Button
                                        text="Alterar Senha"
                                        type={"dark"}
                                        icon={"fa fa-pencil-alt"}
                                        event={() => {
                                            setState({ ...state, exibirCampoNovaSenha: true, form: { ...state.form, senha_atual: null, nova_senha: null } });
                                        }}
                                    />
                                </Grid>
                            )}
                        </Row>
                    </Grid>
                    <Grid cols="2 2 2 2"></Grid>
                    <Grid cols="4 4 4 4">
                        <Button
                            text={<span style={{ fontSize: "clamp(0.6rem, 2vw, 1rem)", whiteSpace: "nowrap" }}>Salvar</span>}
                            type={"success"}
                            icon={"fas fa-check"}
                            event={() => {
                                const registro = {
                                    id: props.usuarioLogado.id,
                                    nome: state.form.nome,
                                    login: state.form.login,
                                    senha_atual: state.form.senha_atual,
                                    nova_senha: state.form.nova_senha,
                                };
                                const callback = () => setState({ ...state, exibirModalEditarPerfil: false, exibirCampoNovaSenha: false, form: { ...formDefault } });
                                props.alterarPerfil({ registro, callback });
                            }}
                        />
                    </Grid>
                    <Grid cols="4 4 4 4">
                        <Button
                            text={<span style={{ fontSize: "clamp(0.6rem, 2vw, 1rem)", whiteSpace: "nowrap" }}>Cancelar</span>}
                            type={"danger"}
                            icon={"fas fa-times"}
                            event={() => {
                                setState({ ...state, exibirModalEditarPerfil: false, exibirCampoNovaSenha: false, form: { ...formDefault } });
                            }}
                        />
                    </Grid>
                    <Grid cols="2 2 2 2"></Grid>
                </Row>
            </ModalAlert>

            <li className="nav-item dropdown">
                <div
                    style={{
                        marginTop: 6,
                        fontSize: window.innerWidth <= 575 ? "0.7rem" : "0.9rem",
                    }}
                >
                    {nome ? `Olá ${nome}, seja Bem-Vindo ao Gradios` : null}
                </div>
            </li>
            <li className="nav-item dropdown" style={{ color: "#BA0000" }}>
                <a className="nav-link" data-toggle="dropdown" href="#/dashboard">
                    <i className="fas fa-bell" style={{ color: "#BA0000" }}></i>
                    <span className="badge badge-warning navbar-badge">
                        {props.lista_notificacao.filter((item) => !item.visto).length > 0 ? props.lista_notificacao.filter((item) => !item.visto).length : ""}
                    </span>
                </a>
                <div className="dropdown-menu dropdown-menu-lg dropdown-menu-right" style={{ backgroundColor: "#BA0000" }}>
                    <div id="toastsContainerTopRight" className="toasts-top-right fixed" style={{ width: 330, marginTop: 33, marginRight: 10 }}>
                        <div className="toast fade show" role="alert" aria-live="assertive" aria-atomic="true">
                            <div className="toast-header">
                                <strong className="mr-auto" style={{ paddingLeft: 110 }}>
                                    Notificações
                                </strong>
                                <button data-dismiss="toast" type="button" className="ml-2 mb-1 close" aria-label="Close">
                                    <span aria-hidden="true" onClick={() => setState({ ...state, notificacaoOpen: false })}>
                                        ×
                                    </span>
                                </button>
                            </div>
                            <div className="toast-body">
                                <div
                                    className={``}
                                    style={{
                                        maxHeight: (window.innerHeight || 0) - 200,
                                        overflow: "auto",
                                    }}
                                >
                                    <div style={{ textAlign: "right" }}>
                                        <a
                                            onClick={() => {
                                                props.lista_notificacao
                                                    .filter((item) => item.visto)
                                                    .forEach((item) => {
                                                        props.setNotificacaoLida(item);
                                                    });
                                            }}
                                        >
                                            <i
                                                className="fas fa-check"
                                                style={{
                                                    fontSize: 14,
                                                    fontWeight: "bold",
                                                    color: "#757575",
                                                    marginRight: 16,
                                                    marginBottom: 16,
                                                    cursor: "pointer",
                                                }}
                                            >
                                                Limpar Vistas
                                            </i>
                                        </a>

                                        <a
                                            onClick={() => {
                                                props.lista_notificacao.forEach((item) => {
                                                    props.setNotificacaoLida(item);
                                                });
                                            }}
                                        >
                                            <i
                                                className="fas fa-check-double"
                                                style={{
                                                    fontSize: 14,
                                                    fontWeight: "bold",
                                                    color: "#757575",
                                                    marginRight: 16,
                                                    marginBottom: 16,
                                                    cursor: "pointer",
                                                }}
                                            >
                                                Limpar Todas
                                            </i>
                                        </a>
                                    </div>
                                    <div className="dropdown-divider"></div>
                                    {props.lista_notificacao.map((item) => {
                                        let dataNotificacaoAtual = `${diasSemana[new Date(item.datahora_inclusao).getDay()]}, ${new Date(item.datahora_inclusao).getDate()}`;
                                        let dataAlterada = false;
                                        if (!dataNotificacao || dataNotificacao != dataNotificacaoAtual) {
                                            dataNotificacao = dataNotificacaoAtual;
                                            dataAlterada = true;
                                        }

                                        let icone = "";

                                        switch (item.tipo) {
                                            case "fatura_importada":
                                                icone = "fas fa-bolt";
                                                break;
                                            case "erro_engenharia":
                                                icone = "fas fa-tasks";
                                                break;
                                            case "engenharia_validada":
                                                icone = "fas fa-tasks";
                                                break;
                                            default:
                                                break;
                                        }

                                        return (
                                            <div key={item.id}>
                                                {dataAlterada ? (
                                                    <div
                                                        style={{
                                                            padding: 4,
                                                            textAlign: "center",
                                                            fontWeight: "bold",
                                                            backgroundColor: "#e0e0e0",
                                                            color: "#424242",
                                                        }}
                                                    >
                                                        {dataNotificacao}
                                                    </div>
                                                ) : null}
                                                <div
                                                    className=""
                                                    style={{ cursor: "pointer" }}
                                                    onClick={() => {
                                                        const link = item.link === "/faturaEngenharia" ? "/fatura-engenharia" : item.link;
                                                        window.location.href = `#${link}`;
                                                        props.setNotificacaoVista(item);
                                                        props.setFiltroFatura({
                                                            ...props.filtroFatura,
                                                            id_cliente: item.id_cliente,
                                                            id_unidade_consumidora: item.id_unidade_consumidora,
                                                        });
                                                        props.getListaFatura();
                                                    }}
                                                >
                                                    <div
                                                        style={{
                                                            fontSize: 14,
                                                            fontWeight: item.visto ? null : "bold",
                                                        }}
                                                    >
                                                        {item.titulo}
                                                    </div>
                                                    <div
                                                        style={{
                                                            fontSize: 13,
                                                            fontWeight: item.visto ? null : "bold",
                                                        }}
                                                    >
                                                        {item.mensagem}
                                                    </div>
                                                    <div
                                                        style={{
                                                            fontSize: 13,
                                                            fontWeight: item.visto ? null : "bold",
                                                        }}
                                                    >
                                                        {item.nome_cliente}
                                                    </div>
                                                    <div
                                                        style={{
                                                            fontSize: 13,
                                                            fontWeight: item.visto ? null : "bold",
                                                        }}
                                                    >
                                                        {item.nome_unidade_consumidora}
                                                    </div>
                                                    <a
                                                        style={{
                                                            display: "flex",
                                                            flexDirection: "row",
                                                            justifyContent: "space-between",
                                                        }}
                                                    >
                                                        <div
                                                            style={{
                                                                fontSize: 12,
                                                                fontWeight: "bold",
                                                                color: "#424242",
                                                            }}
                                                        >
                                                            {DateFormat.formatarDataHoraSqlParaTela(item.datahora_inclusao).split(" ")[1]}
                                                        </div>
                                                    </a>
                                                </div>
                                                <div className="dropdown-divider"></div>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </li>
            <li className="nav-item dropdown" style={{ color: "#BA0000" }}>
                <a
                    title="Entrar em contato pelo WhatsApp"
                    href="https://wa.me/5555996214926?text=Olá, gostaria de mais informações!"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: "#FFF" }}
                >
                    <img src={avatar} height={30} style={{ marginRight: 10 }} alt="Gradios"></img>
                    <img style={{ marginTop: -10, marginLeft: -15 }} src={whatsappLogo} alt="" height={20} />
                </a>
            </li>
            <li className="nav-item dropdown" style={{ color: "#BA0000" }}>
                <a className="nav-link" data-toggle="dropdown" href="#">
                    <i className="fas fa-user" style={{ color: "#BA0000" }}></i>
                </a>
                <div className="dropdown-menu dropdown-menu-lg dropdown-menu-right" style={{ backgroundColor: "#BA0000" }}>
                    <div
                        style={{
                            color: "#fff",
                            padding: 12,
                            fontWeight: "bold",
                            textAlign: "center",
                        }}
                    >
                        <span className="">Perfil</span>
                    </div>
                    <div className="dropdown-divider"></div>
                    <div style={{ color: "#fff", padding: 12 }}>
                        <i className="fas fa-user mr-2"></i> Nome
                        <span className="float-right text-sm" style={{ color: "#fff" }}>
                            {nome}
                        </span>
                    </div>
                    <div className="dropdown-divider"></div>
                    <div style={{ color: "#fff", padding: 12 }}>
                        <i className="fas fa-envelope mr-2"></i> Usuário
                        <span className="float-right text-sm" style={{ color: "#fff" }}>
                            {login}
                        </span>
                    </div>
                    <div className="dropdown-divider"></div>
                    <button
                        onClick={() => {
                            setState({ ...state, exibirModalEditarPerfil: true, form: { ...formDefault, nome, login } });
                        }}
                        style={{ color: "#FFF", backgroundColor: "#7b0505", margin: "4px 5px", width: "97%" }}
                        className="btn btn-block btn-sm"
                    >
                        <i className="fas fa-pencil-alt mr-2"></i>
                        <span>Editar Perfil</span>
                    </button>
                    <button
                        onClick={() => {
                            props.logout();
                            // props.history.push("/dashboard");
                        }}
                        style={{ color: "#BA0000", backgroundColor: "#fff", margin: "0px 5px 4px 5px", width: "97%" }}
                        className="btn btn-block btn-light btn-sm"
                    >
                        <i className="fas fa-sign-out-alt mr-2"></i>
                        <span>Sair</span>
                    </button>
                </div>
            </li>
        </ul>
    );
}

const mapStateToProps = (state) => ({
    usuarioLogado: state.auth.usuarioLogado,
    lista_notificacao: state.notificacao.lista,
    filtroFatura: state.fatura.filtro,
});
const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            logout,
            buscarSessao,
            alterarPerfil,
            getListaNotificacao,
            setNotificacaoVista,
            setNotificacaoLida,
        },
        dispatch
    );
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Navbar));
